import Vue from 'vue';
import App from './App.vue';
import store from './store';

import meta from './vue-meta';

import '@/assets/styles/styles.scss';

Vue.config.productionTip = false;

new Vue({
  store,
  meta,
  render: (h) => h(App),
}).$mount('#app');
